module.exports = __webpack_public_path__ + "static/downtown-aurora-198bb24daf115f0fe4c7c46a7649895e.jpg";